export const CrumbTitle = (path) => {
  switch (path) {
    case "baseclientmanagement":
      return "Base Client Management";
    case "baseclientdetails":
      return "Base Client Information";
    case "usermanagement":
      return "User Management";
    case "userinfo":
      return "User Information";
    case "billingreports":
      return "Billing Reports";
    case "billingdetails":
      return "Billing Information";
    case "requisitions":
      return "Requisitions";
    case "heredotcom":
      return "Here.Com";
    case "heredotcomdetailed":
      return "Here.Com Information";
    case "careersclientmanagement":
      return "Careers Client Management";
    case "careersclientdetails":
      return "Careers Client Information";
    case "billingtiers":
      return "Billing Tiers";
    case "billingtiersdetailed":
      return "Billing Tiers Information";
    case "inboundfeeds":
      return "Inbound Feeds";
    case "userlogs":
      return "User Logs";
    case "googleaccounts":
      return "Google Account";
    case "googleaccountsdetailed":
      return "Google Accounts Information";
    case "outboundfeeds":
      return "Outbound Feeds";
    case "outboundfeeddetailed":
      return "Outbound Feed Information";
    case "outboundtemplatedetailed":
      return "Outbound Template Feed";
    case "atsapidetailed":
      return "ATS API Information";
    case "profile":
      return "Profile";
    case "emailtemplates":
      return "Email Templates";
    case "emailtemplatedetailed":
      return "Email Template Information";
    case "inboundfeeddetailed":
      return "Inbound Feed Information";
    case "featuresenabled":
      return "Features Enabled";
    case "abtesting":
      return "A/B Testing";
    default:
      return path;
  }
};
